export enum ResultStatus {
  UNAUTHORIZED = 'Unauthorized',
  UNAUTHENTICATED = 'Unauthenticated',
  ERROR = 'Error',
  SUCCESS = 'Success',
}
